import React, { useContext, useEffect, useState, } from "react";
import LoadingMessage from "./LoadingMessage";
import ContentContainer from "../atoms/ContentContainer";
import FormTitle from "../atoms/FormTitle";
import Button from "../atoms/Button";
import FormStepper from "../molecules/FormStepper";
import FormStep from "../atoms/FormStep";
import { Route, Switch } from "react-router";
import PageNotFound from "../pages/PageNotFound";
import { useUser } from "../Context/UserContext";
import { FormContext } from "../Context/FormContext";
import useApiCall from "../Hooks/useApiCall";
import Http, { endpoint } from "../../Http";
import * as Endpoint from "../../Http";
import RedirectAs404 from "../pages/RedirectAs404";
import * as Routes from "../../Routes";
const FormRenderer = ({ formCode, steps, transformData, history, location, }) => {
    const [step, setStep] = useState(0);
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadFormDataErrors, setLoadFormDataErrors,] = useState(null);
    const { user } = useUser();
    const { dirty, setDirty } = useContext(FormContext);
    const [loadFormDataCall, , , loadFormDataLoading] = useApiCall("get", endpoint(Endpoint.FORM, { form: formCode }));
    const getCurrentStep = () => {
        let currentStep = 0;
        steps.forEach((step, index) => {
            if (location.pathname === step.url) {
                currentStep = index;
            }
        });
        return currentStep;
    };
    useEffect(() => {
        const currentStep = getCurrentStep();
        setStep(getCurrentStep());
        if (currentStep === 0 && !location.pathname.includes(steps[0].url)) {
            history.replace(steps[0].url);
        }
    }, [location]);
    const loadFormData = () => {
        setLoadFormDataErrors(null);
        loadFormDataCall()
            .then((result) => {
            setForm(transformData
                ? transformData(result.data.data)
                : result.data.data);
            if (getCurrentStep() > result.data.latest_step) {
                goToStep(result.data.latest_step);
            }
            if (result.data.completed_at) {
                goToStep(steps.length);
                return;
            }
        })
            .catch((res) => {
            setLoadFormDataErrors(res.genericErrors);
        });
    };
    useEffect(loadFormData, []);
    if (!user) {
        return React.createElement(RedirectAs404, null);
    }
    const updateForm = (step, stepData) => {
        const currentDirty = dirty;
        setLoading(true);
        setDirty(true);
        Http.put(endpoint(Endpoint.VALIDATE, { form: formCode, step: step }), stepData)
            .then((res) => {
            setErrors({});
            setForm(Object.assign(Object.assign({}, form), stepData));
            if (res.data.completed_at) {
                goToStep(steps.length);
                return;
            }
            setLoading(false);
            next();
        })
            .catch((err) => {
            setErrors(err.fieldErrors);
            setLoading(false);
            setDirty(currentDirty);
        });
    };
    const next = () => {
        goToStep(step + 1);
    };
    const prev = () => {
        goToStep(step - 1);
    };
    const goToStep = (step) => {
        setDirty(false);
        if (step >= steps.length) {
            history.push(Routes.THANKS, { finalized: true });
            return;
        }
        if (step < 0)
            step = 0;
        setStep(step);
        history.push(steps[step].url);
    };
    return (React.createElement(React.Fragment, null,
        loadFormDataLoading && (React.createElement(LoadingMessage, { title: "Ophalen gegevens" })),
        !loadFormDataLoading && loadFormDataErrors && (React.createElement(ContentContainer, null,
            React.createElement(FormTitle, null, "Fout tijdens ophalen gegevens"),
            React.createElement(Button, { onClick: loadFormData }, "Probeer nogmaals"))),
        !loadFormDataLoading && !loadFormDataErrors && (React.createElement(React.Fragment, null,
            steps[step].stepIndex !== undefined && (React.createElement(FormStepper, null, steps
                .filter((stepConfig) => stepConfig.stepIndex !== undefined)
                .map((stepConfig, index) => {
                if (stepConfig.stepIndex === undefined) {
                    return null;
                }
                return (React.createElement(FormStep, { key: index, label: stepConfig.title, number: String(index + 1), isActive: stepConfig.stepIndex === step, isCompleted: step > stepConfig.stepIndex }));
            }))),
            React.createElement(Switch, null,
                steps.map((step, index) => (React.createElement(Route, { path: `${step.url}`, key: index, render: (props) => (React.createElement(step.component, Object.assign({ formData: form, errors: errors, loading: loading, user: user, setFormStep: (stepData) => updateForm(index, stepData), setPreviousStep: prev, index: index }, props))) }))),
                React.createElement(Route, { component: PageNotFound }))))));
};
export default FormRenderer;
